import _extends from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React, { forwardRef } from "react";
import { Box, Flex } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var UpsellCTAWidgetZone = /*#__PURE__*/forwardRef(function (props, ref) {
  return ___EmotionJSX(Box, _extends({
    ref: ref,
    "data-testid": "OnePassCTAWidget"
  }, props));
});
UpsellCTAWidgetZone.displayName = "UpsellCTAWidgetZone";
export var UpsellCTAWidgetPrimaryZone = function UpsellCTAWidgetPrimaryZone(props) {
  return ___EmotionJSX(Flex, _extends({
    flexDirection: "column",
    px: 4,
    py: 3,
    fontFamily: "onePass",
    color: "onePass.textPrimary",
    borderRadius: "corner",
    borderColor: "onePass.primary",
    borderWidth: 2,
    borderStyle: "solid",
    cursor: "pointer",
    role: "button"
  }, props));
};